import {
  buildEntityActions,
  buildEntityApi,
  buildEntitySelectors,
} from '@zapier/toolbox-redux-framework';

import { selectAppId } from 'app/developer-v3/store/shared/selectors';

export const type = 'cliAppEventStats';

export const api = buildEntityApi(type, (_path, getState) => {
  const state = getState();
  const appId = selectAppId(state);
  return `/api/platform/cli/apps/${appId}/events/stats`;
});

export const selectors = buildEntitySelectors(type, () => {});

export const actions = buildEntityActions(type, selectors, api);
